<template>
    <div>
      <v-dialog v-model="mostrarDialogoConfirmacaoNaoCredenciamento" persistent max-width="800" :disabled="!deveMostarBotaoNaoCredenciar">
        <v-list-tile-title style="user-select: none; height: auto" slot="activator">
          <v-btn flat
              outline
              color="#f55353"
              class="text-uppercase"
              v-text="'NÃO CREDENCIAR'"
              style="user-select: none" slot="activator"
              :disabled="!deveMostarBotaoNaoCredenciar"
          />
        </v-list-tile-title>

        <v-card>
          <v-card-title class="primary modal-title" primary-title>
            Motivo
          </v-card-title>
          <v-card-text class="pb-0 az-form-content">
                <v-textarea v-model="value.motivoNaoCredenciamento"
                            :error-messages="errors.collect('Motivo')"
                            v-validate="mostrarDialogoConfirmacaoNaoCredenciamento? 'required' : ''"
                            :name="'Motivo'"
                            label="Motivo não credenciamento"
                            placeholder="Informe o motivo"
                            rows="10"
                            maxlength="1000"
                            :counter="1000"
                            class="required-field"/>
            </v-card-text>
            <v-card-actions class="acoes justify-space-between">
                <v-btn class="ml-3" color="#777" flat @click="mostrarDialogoConfirmacaoNaoCredenciamento = false">
                  Cancelar
                </v-btn>
                <v-btn class="botao-primario confirmar mr-3" flat @click="confirmarNaoCredenciamento">
                  Salvar
                </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>

export default {
    name: 'AcaoNaoCredenciarSolicitacaoCredenciamento',
    props: {
      value: {
        default: () => {
          return {}
        }
      },
      deveMostarBotaoNaoCredenciar: {
        type: Boolean,
        required: false
      },
    },
    data() {
        return {
            mostrarDialogoConfirmacaoNaoCredenciamento: false
        }
    },
    methods: {
        fecharDialogoConfirmacaoNaoCredenciamento(){
            this.mostrarDialogoConfirmacaoNaoCredenciamento = false
        },
        async confirmarNaoCredenciamento(){
            await this.validarCampos()
            this.fecharDialogoConfirmacaoNaoCredenciamento()
            this.$emit('confirmarNaoCredenciamento')
        },
        async validarCampos(){
            const estaValidado = await this.$validator.validateAll()
            if(!estaValidado){
                throw new Error('Preencha o campo Motivo obrigatório.')
            }
        }
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
          padding 0
          margin 0
          color #fff
          box-sizing border-box
          min-width 25px

    .botao-primario
      padding 0 25px
      border 1px solid #0067a5
      background-color #0067a5 !important
      color #fff !important
      box-sizing border-box
      margin-left 15px !important

    .acoes
      padding 20px 0 !important

</style>